/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MapHeader.scss';
import SearchBox from '../SearchBox/SearchBox';
import MapNav from '../MapNav';
import UserPopup from '../Modals/UserPopup/UserPopup';
import Welcome from '../Modals/Welcome/Welcome';
import LoginModal from '../Modals/LoginModal';
import RegisterModal from '../Modals/RegisterModal/RegisterModal';
import Settings from '../Modals/Settings';
import LayersModal from '../Modals/LayersModal';
import SpatialAnalysis from '../Modals/SpatialAnalysis/SpatialAnalysis';
import MeasureTools from '../Modals/MeasureTools/MeasureTools';
import TextToSpeech from '../Modals/Speech/TextToSpeech';
import PrintModal from '../Modals/PrintModal/PrintModal';
import SideDescription from '../Modals/SideDescription/SideDescription';

import { districtsWithGraveyards } from '../../constants';
import { setLocale } from '../../actions/intl';
import { setRuntimeVariable } from '../../actions/runtime';
import { createUser, fetchUser, logOut } from '../../actions/user';
import { incrementBounceCounter, toggleSearchboxStatus } from '../../actions/style';
import { setPrintStatus, changePrintToPdfStatus } from '../../actions/printSettings';
import { setPrevMap, setNextMap } from '../../actions/routing';
import { pobierzListGmin } from '../../actions/gminy';
import { sideDescriptionView, fetchGraveyard } from '../../actions/district';
import { onClickParcel, zoomingRectangle, blockingRectangle } from '../../actions/mapTools';
import TrapezoidMenu from '../TrapezoidMenu';
import xbutton from './img/x.png';
import LanguageSwitcher from '../LanguageSwitcher';
// import SearchInvestModal from '../Modals/SearchInvestModal/SearchInvestModal';

const mapState = state => ({
  intl: state.intl,
  district: state.district.district,
  user: state.user,
  bounceCounter: state.style.bounceCounter,
  printModalStatus: state.printSettings.printModalStatus,
  fontSize: state.runtime.fontSize,
  messages: state.intl.messages,
  powiaty: state.powiaty,
  arePowiatyFetched: state.powiaty.arePowiatyFetched,
  gminy: state.gminy,
  areGminyFetched: state.gminy.areGminyFetched,
  sideDescription: state.district.sideDescription,
  parcelState: state.parcelState,
  isZooming: state.tools.isZooming,
  isZoomBlocked: state.tools.isZoomBlocked,
  currentComposition: state.layers.currentMapComposition
});
const mapDispatch = {
  setLocale,
  setRuntimeVariable,
  createUser,
  fetchUser,
  logOut,
  pobierzListGmin,
  incrementBounceCounter,
  toggleSearchboxStatus,
  setPrintStatus,
  setPrevMap,
  setNextMap,
  sideDescriptionView,
  onClickParcel,
  zoomingRectangle,
  blockingRectangle,
  fetchGraveyard,
  changePrintToPdfStatus,
};

@connect(
  mapState,
  mapDispatch,
)
class MapHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPopup: null,
      isLoggedIn: false,
      username: 'gregorowicz.k@gmail.com',
      showLoginModal: false,
      showRegisterModal: false,
      modalUser: null,
      modalPasswd: null,
      loginModalHasError: null,
      intl: this.props.intl,
    };
    // this.props.fetchUser('admin@krosno.pl', 'KrosnoEspdp', 'krosno');
    // this.props.fetchUser('Urzędnik', 'cat', 'gmina_cieszanow');

    // this.props.fetchUser('admin@swiebodzice.pl', 'gdKnqsd3bKr7hNys', 'swiebodzice');
    // this.props.fetchUser('admin@zarow.pl', 'cuM7fJXmdd27rn5w', 'gmina_zarow');
    // this.props.fetchUser('admin@strzegom.pl', 'NGZGbbULPKpk5qWq', 'gmina_strzegom');

    this.onInfoClick = this.onInfoClick.bind(this);
    this.onSearchInvest = this.onSearchInvest.bind(this);
    this.onPrintClick = this.onPrintClick.bind(this);
    this.onSpatialAnalysisClick = this.onSpatialAnalysisClick.bind(this);
    this.onMeasureToolsClick = this.onMeasureToolsClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onUserIconClick = this.onUserIconClick.bind(this);
    this.onShowModal = this.onShowModal.bind(this);
    this.openLoginModal = this.openLoginModal.bind(this);
    this.closeLoginModal = this.closeLoginModal.bind(this);
    this.openRegisterModal = this.openRegisterModal.bind(this);
    this.closeRegisterModal = this.closeRegisterModal.bind(this);
    this.logIn = this.logIn.bind(this);
    this.onChangeModalUser = this.onChangeModalUser.bind(this);
    this.onChangeModalPasswd = this.onChangeModalPasswd.bind(this);
    this.logOutUser = this.logOutUser.bind(this);
    this.onCloseSettings = this.onCloseSettings.bind(this);
    this.onLangSwitchIconClick = this.onLangSwitchIconClick.bind(this);
  }

  componentDidMount() {
    districtsWithGraveyards.includes(this.props.district.prefix)
    ? this.showLeftSideBar()
    : this.props.sideDescriptionView(false, null)
  }

  componentWillReceiveProps(nextProps){
    if (JSON.stringify(nextProps.intl) !== JSON.stringify(this.state.intl)) {
      this.setState({
        intl: nextProps.intl,
      });
    }
  }

  onSpatialAnalysisClick = () => {
    this.setState({
      currentPopup: this.state.currentPopup === 'SpatialAnalysis' ? null : 'SpatialAnalysis',
    });
  };
  onSpeakClick = e => {
    e.preventDefault();
    this.setState({
      currentPopup: this.state.currentPopup === 'TextToSpeech' ? null : 'TextToSpeech',
    });
  };
  onMeasureToolsClick = e => {
    e.preventDefault();
    this.setState({
      currentPopup: this.state.currentPopup === 'MeasureTools' ? null : 'MeasureTools',
    });
  };
  onLayerModalClick = e => {
    //e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'layerModal' ? null : 'layerModal' });
  };
  onInfoClick = e => {
    e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'info' ? null : 'info' });
    if (this.props.bounceCounter < 3) {
      this.props.incrementBounceCounter();
    }
  };
  onSearchInvest = e => {
    e.preventDefault();
    this.props.sideDescriptionView(true, null);
  };
  onUserIconClick = e => {
    e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'user_login' ? null : 'user_login' });
    if (this.props.bounceCounter < 3) {
      this.props.incrementBounceCounter();
    }
  };
  onLangSwitchIconClick = e => {
    e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'langswitch' ? null : 'langswitch' });
    if (this.props.bounceCounter < 3) {
      this.props.incrementBounceCounter();
    }
  };
  onShowModal = e => {
    e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'settings' ? null : 'settings' });
  };
  toggleSearchbox = e => {
    e.preventDefault();
    this.setState({ currentPopup: this.state.currentPopup === 'searchbox' ? null : 'searchbox' });
    this.props.toggleSearchboxStatus();
  };
  onPrintClick = e => {
    e.preventDefault();
    this.props.setPrintStatus();
  };
  onPDFClick = e => {
    e.preventDefault();
    this.props.changePrintToPdfStatus(true);
  };
  setPopup = obj => {
    this.state.currentPopup === null
      ? this.setState({ currentPopup: obj })
      : this.setState({ currentPopup: null });
  };
  changeLocale = locale => {
    this.props.setLocale({ locale });
  };
  changeSize = size => {
    if (size === 'increase') {
      this.props.setRuntimeVariable({ name: 'fontSize', value: this.props.fontSize + 0.2 });
    } else {
      this.props.setRuntimeVariable({ name: 'fontSize', value: this.props.fontSize - 0.2 });
    }
  };

  onPrevClick = () => {
    this.props.setPrevMap();
  };

  onNextClick = () => {
    this.props.setNextMap();
  };

  closeLoginModal = () => {
    this.setState({ showLoginModal: false });
  };

  openLoginModal = () => {
    this.setState({ showLoginModal: true });
  };

  closeRegisterModal = () => {
    this.setState({ showRegisterModal: false });
  };

  openRegisterModal = () => {
    this.setState({ showRegisterModal: true });
  };

  logIn = e => {
    e.preventDefault();
    this.props
      .fetchUser(this.state.modalUser, this.state.modalPasswd, this.props.district.prefix)
      .then(response => {
        if (response.status === 200) {
          this.closeLoginModal();
        } else {
          throw response;
        }
      })
  };

  logOutUser = e => {
    this.props.logOut();
  };

  onChangeModalUser = e => {
    this.setState({ modalUser: e.target.value });
  };

  onChangeModalPasswd = e => {
    this.setState({ modalPasswd: e.target.value });
  };

  onCloseSettings = e => {
    this.setState({ currentPopup: null });
  };

  handleCloseSideDescription = () => {
    this.props.sideDescriptionView(false);
    this.props.onClickParcel(false);
  };

  zooming = e => {
    e.preventDefault();
    this.setState(
      {
        currentPopup: this.state.currentPopup === 'zooming' ? null : 'zooming',
      },
      () => {
        this.props.zoomingRectangle(!this.props.isZooming);
      },
    );
  };

  blockingRectangle = e => {
    e.preventDefault();
    this.setState(
      {
        currentPopup: this.state.currentPopup === 'blocking' ? null : 'blocking',
      },
      () => {
        this.props.blockingRectangle(!this.props.isZoomBlocked);
        this.props.zoomingRectangle(!this.props.isZooming);
      },
    );
  };
  testowyStyle = () => {
    return {
      border: 'none',
      backgroundColor: '#f5f5f5',
      position: 'absolute',
      top: '227px',
      left: '-45px',
      backgroudColor: 'white',
      color: '#336633',
      borderBottom: '4px solid #bdbdbd',
      fontFamily: 'Roboto, sans-serif !important',
      width: '140px',
      height: '50px',
      transform: 'rotate(90deg)',
      boxShadow: '-0.5px -0.5px 5px 0.5px rgba(0, 0, 0, 0.75)',
      textTransform: 'uppercase'
    }
  }
  showLeftSideBar = () => {
    this.props.sideDescriptionView(true, null, 'cmentarze')
    if (districtsWithGraveyards.includes(this.props.district.prefix)) {
      this.props.fetchGraveyard(this.props.district.prefix);
    }
  }

  render() {

    return (
      <nav className={this.props.printModalStatus === false ? 'header' : 'header-in-print'}>
        <div className={'container-fluid'}>
          {/*<div className={"navbar-header"}>
            <button type="button" className={"navbar-toggle collapsed"} data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
              <span className={"sr-only"}>Toggle navigation</span>
              <span className={"icon-bar"} />
              <span className={"icon-bar"} />
              <span className={"icon-bar"} />
            </button>
          </div>*/}
          {this.props.currentComposition && this.props.currentComposition.nazwa == "CMENTARZE" ?
            <button key={this.state.intl.langKeys.wyszGrob} onClick={() => this.showLeftSideBar()} style={this.testowyStyle()}>{this.state.intl.langKeys.wyszGrob}</button>
            : null
          }
          <TrapezoidMenu prefix={this.props.district ? this.props.district.prefix : ''} />
          <div id={'navbar'} className={'navContainer'}>
            <div id="big-screen-searchbox">
              <SearchBox />
            </div>
            <MapNav
              onPrevClick={this.onPrevClick}
              onNextClick={this.onNextClick}
              onInfoClick={this.onInfoClick}
              onUserIconClick={this.onUserIconClick}
              onLayerModalClick={e => this.onLayerModalClick(e)}
              onSpatialAnalysisClick={this.onSpatialAnalysisClick}
              onMeasureToolsClick={this.onMeasureToolsClick}
              onSpeakClick={this.onSpeakClick}
              onPrintClick={this.onPrintClick}
              onPDFClick={this.onPDFClick}
              onLangSwitchIconClick={this.onLangSwitchIconClick}
              toggleSearchbox={this.toggleSearchbox}
              currentPopup={this.state.currentPopup}
              zoomingRectangle={this.zooming}
              blockingRectangle={this.blockingRectangle}
              onSearchInvest={this.onSearchInvest}
              prefix={this.props.district ? this.props.district.prefix: ''}
            />
            {this.state.currentPopup === 'searchbox' ? <SearchBox /> : null}
            <div className="mainNav-modals">
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                {this.state.currentPopup === 'SpatialAnalysis' ? (
                  <SpatialAnalysis
                    xbutton={xbutton}
                    onSpatialAnalysisClick={() => this.onSpatialAnalysisClick()}
                  />
                ) : null}
              </ReactCSSTransitionGroup>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                {this.state.currentPopup === 'MeasureTools' ? (
                  <MeasureTools xbutton={xbutton} />
                ) : null}
              </ReactCSSTransitionGroup>
              <ReactCSSTransitionGroup
                transitionName={this.props.bounceCounter > 2 ? 'fade' : 'fade'}
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                {this.state.currentPopup === 'TextToSpeech' ? (
                  <TextToSpeech xbutton={xbutton} onSpeakClick={this.onSpeakClick} />
                ) : null}
              </ReactCSSTransitionGroup>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                {this.state.currentPopup === 'layerModal' ? (
                  <LayersModal
                    xbutton={xbutton}
                    onLayerModalClick={() => this.onLayerModalClick()}
                  />
                ) : null}
              </ReactCSSTransitionGroup>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                {this.state.currentPopup === 'langswitch' ? (
                  <LanguageSwitcher onClick={this.onLangSwitchIconClick} />
                ) : null}
              </ReactCSSTransitionGroup>

              <ReactCSSTransitionGroup
                transitionName={this.props.bounceCounter > 2 ? 'fade' : 'fade'}
                transitionEnterTimeout={1}
                transitionLeaveTimeout={1}
              >
                <ReactCSSTransitionGroup
                  transitionName="moveFromLeft"
                  transitionEnterTimeout={0}
                  transitionLeaveTimeout={0}
                >
                  {this.props.sideDescription.view ? (
                    <SideDescription closeSideDescription={this.handleCloseSideDescription} />
                  ) : null}
                </ReactCSSTransitionGroup>
                {this.state.currentPopup === 'print' ? <PrintModal /> : null}

                {this.state.currentPopup === 'info' ? (
                  <Welcome xbutton={xbutton} onInfoClick={this.onInfoClick} prefix={this.props.district.prefix} />
                ) : null}

                {this.state.currentPopup === 'user_login' ? (
                  <UserPopup
                    onUserIconClick={this.onUserIconClick}
                    isLoggedIn={this.props.user && this.props.user.isLoggedIn}
                    username={this.props.user && this.props.user.user}
                    openLoginModal={this.openLoginModal}
                    openRegisterModal={this.openRegisterModal}
                    logOutUser={this.logOutUser}
                    onShowModal={this.onShowModal}
                    changeLanguage={this.changeLocale}
                    user={this.props.user}
                    changeSize={this.changeSize}
                    intl={this.state.intl}
                  />
                ) : null}
                {this.state.currentPopup === 'settings' ? (
                  <Settings
                    xbutton={xbutton}
                    district={this.props.district}
                    user={this.props.user}
                    onCloseSettings={this.onCloseSettings}
                  />
                ) : null}
              </ReactCSSTransitionGroup>
              <LoginModal
                logIn={this.logIn}
                open={this.openLoginModal}
                close={this.closeLoginModal}
                showModal={this.state.showLoginModal}
                onChangeModalPasswd={this.onChangeModalPasswd}
                onChangeModalUser={this.onChangeModalUser}
                hasError={this.state.loginModalHasError}
              />
              <RegisterModal
                open={this.openRegisterModal}
                close={this.closeRegisterModal}
                showModal={this.state.showRegisterModal}
                arePowiatyFetched={this.props.arePowiatyFetched}
                powiaty={this.props.powiaty}
                gminy={this.props.gminy}
                areGminyFetched={this.props.areGminyFetched}
                pobierzListGmin={this.props.pobierzListGmin}
                createUser={this.props.createUser}
              />
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

const MapHead = connect(
  mapState,
  mapDispatch,
)(MapHeader);

export default withStyles(s)(MapHead);



// WEBPACK FOOTER //
// src/components/MapHeader/MapHeader.js